export const generalKnowledgeQuestions = [
  {
    id: 'general-001',
    category: 'General Knowledge',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'How many degrees are in a full circle?',
    options: ['90', '180', '270', '360'],
    answer: '360',
    insight: 'A full rotation around a circle measures 360 degrees.',
    tags: ['math', 'geometry', 'basics'],
    points: 10,
  },
  {
    id: 'general-002',
    category: 'General Knowledge',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'What is the main ingredient in guacamole?',
    options: ['Avocado', 'Tomato', 'Lime', 'Onion'],
    answer: 'Avocado',
    insight: 'Avocado gives guacamole its creamy texture.',
    tags: ['food', 'everyday', 'trivia'],
    points: 10,
  },
  {
    id: 'general-003',
    category: 'General Knowledge',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'A leap year usually has 366 days.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Leap years add one day to keep calendars aligned with Earth orbit.',
    tags: ['calendar', 'time', 'true false'],
    points: 10,
  },
  {
    id: 'general-004',
    category: 'General Knowledge',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which board game uses rooks, bishops, and pawns?',
    options: ['Chess', 'Checkers', 'Go', 'Backgammon'],
    answer: 'Chess',
    insight: 'Chess pieces include kings, queens, rooks, bishops, knights, and pawns.',
    tags: ['games', 'strategy', 'board games'],
    points: 20,
  },
  {
    id: 'general-005',
    category: 'General Knowledge',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'What is the currency of the United Kingdom?',
    options: ['Euro', 'Pound Sterling', 'Dollar', 'Franc'],
    answer: 'Pound Sterling',
    insight: 'The pound sterling is one of the oldest currencies still in use.',
    tags: ['currency', 'uk', 'money'],
    points: 20,
  },
  {
    id: 'general-006',
    category: 'General Knowledge',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'The first modern Olympic Games were held in Athens.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'The first modern Olympics took place in Athens in 1896.',
    tags: ['sports', 'olympics', 'history'],
    points: 20,
  },
  {
    id: 'general-007',
    category: 'General Knowledge',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'What does the Roman numeral L represent?',
    options: ['10', '50', '100', '500'],
    answer: '50',
    insight: 'In Roman numerals, L equals 50.',
    tags: ['numbers', 'roman numerals', 'symbols'],
    points: 20,
  },
  {
    id: 'general-008',
    category: 'General Knowledge',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which language has the most native speakers worldwide?',
    options: ['English', 'Mandarin Chinese', 'Spanish', 'Hindi'],
    answer: 'Mandarin Chinese',
    insight: 'Mandarin Chinese has the largest native-speaker population.',
    tags: ['language', 'world', 'population'],
    points: 30,
  },
  {
    id: 'general-009',
    category: 'General Knowledge',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'What is the smallest prime number?',
    options: ['0', '1', '2', '3'],
    answer: '2',
    insight: 'Two is the smallest prime number and the only even prime.',
    tags: ['math', 'prime numbers', 'logic'],
    points: 30,
  },
  {
    id: 'general-010',
    category: 'General Knowledge',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'The word alphabet comes from the first two letters of the Greek alphabet.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Alphabet comes from alpha and beta.',
    tags: ['language', 'words', 'greek'],
    points: 30,
  },
];
